
import CelestaApp from "../components/CelestaApp";

export default function Celesta() {
 return <CelestaApp />;
}
